/*
 * @Author: changcheng
 * @LastEditTime: 2022-08-23 16:43:30
 */
const Expertbase = () => {
  return <>Expertbase</>;
};

export default Expertbase;
